module.exports = __webpack_public_path__ + "static/media/Outfit_600SemiBold.0458369a.ttf";